import history from "../../utils/history";
import auth0 from "auth0-js";
import axios from "axios";
import { API_BASE_URL, AUTH_CONFIG } from "../../environment";

export default class Auth {
  auth0 = new auth0.WebAuth({
    domain: AUTH_CONFIG.domain,
    clientID: AUTH_CONFIG.clientID,
    redirectUri: `${window.location.origin}/callback`,
    audience: AUTH_CONFIG.audience,
    responseType: AUTH_CONFIG.responseType,
    scope: AUTH_CONFIG.scope
  });

  constructor() {
    this.login = this.login.bind(this);
    this.logout = this.logout.bind(this);
    this.handleAuthentication = this.handleAuthentication.bind(this);
    this.isAuthenticated = this.isAuthenticated.bind(this);
  }

  login() {
    this.auth0.authorize();
  }

  handleAuthentication() {
    this.auth0.parseHash((err, authResult) => {
      if (authResult && authResult.accessToken && authResult.idToken) {
        // console.log('DEBUG: authResult', authResult);
        // console.log('DEBUG: idTokenPayload', authResult.idTokenPayload);
        // console.log("AUTH: this", this);
        this.setSession(authResult);
        this.createUser(authResult);
        history.replace("/");
      } else if (err) {
        history.replace("/");
        // console.log(err);
        alert(`Error: ${err.error}. Check the console for further details.`);
      }
    });
  }

  setSession(authResult) {
    // Set the time that the access token will expire at
    let expiresAt = JSON.stringify(
      authResult.expiresIn * 1000 + new Date().getTime()
    );
    localStorage.setItem("access_token", authResult.accessToken);
    localStorage.setItem("id_token", authResult.idToken);
    localStorage.setItem("expires_at", expiresAt);
    // navigate to the home route
    history.replace("/");
  }

  logout() {
    // Clear access token and ID token from local storage
    localStorage.removeItem("access_token");
    localStorage.removeItem("id_token");
    localStorage.removeItem("expires_at");
    // navigate to the home route
    history.replace("/");
  }

  isAuthenticated() {
    // Check whether the current time is past the
    // access token's expiry time
    let expiresAt = JSON.parse(localStorage.getItem("expires_at"));
    return new Date().getTime() < expiresAt;
  }

  async createUser(authResult) {
    try {
      const res = await axios.post(
        `${API_BASE_URL}/users`,
        authResult.idTokenPayload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authResult.accessToken}`,
            tikkiuserid: `${authResult.idToken}`
          }
        }
      );
      // console.log("AUTH: createUser res", res);
      return res;
    } catch (error) {
      // console.log("AUTH: createUser error", error);
      return error;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Auth/Auth.js